function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeacherBro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-143"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.08,56.51S251.53,30.36,179.33,72,70.7,196.29,39.42,262.5,26.14,396.05,81.26,426.76,173.85,412.2,251.16,410s98.11,8.85,162.27-34.83S489.18,228.34,438.57,152,325.08,56.51,325.08,56.51Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.08,56.51S251.53,30.36,179.33,72,70.7,196.29,39.42,262.5,26.14,396.05,81.26,426.76,173.85,412.2,251.16,410s98.11,8.85,162.27-34.83S489.18,228.34,438.57,152,325.08,56.51,325.08,56.51Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Blackboard--inject-143"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 32.56,
    y1: 297,
    x2: 482.05,
    y2: 297,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.56,
    y1: 303.65,
    x2: 482.05,
    y2: 303.65,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.42,
    y: 48.97,
    width: 337.36,
    height: 207.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.42,
    y: 245.23,
    width: 337.36,
    height: 10.9,
    style: {
      fill: "#969696",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.42,
    y: 256.02,
    width: 337.36,
    height: 6.98,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.57,177.86s-3.77-.32-12.39-10.44S318.87,139.9,335.37,139s25,16.45,19.71,26.57-13.7,13.29-13.7,13.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.45,180.39s-17-.63-15.55,1,18.61.95,14.74,2.21-18,0-13.09,2.22,17.12-.64,14.52.63-15.55.95-11.86,2.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.81,175.64s-5.29-13-7.29-16.76S324.58,151,325,155.4s4.2,4.11,7.58.32-.92-6.33-1.2-1.27,4.47,5.06,5.94,1.27-1.65-4.43-1.26,0,3.92,3.48,5,.31-.91-6.32-1.18-1.58,1.29,5.38,3.87,4.43,3.27-7.59,1.16-3.8-6.82,20.25-6.82,20.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 335.67,
    y1: 127.88,
    x2: 335.28,
    y2: 134.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 310.82,
    y1: 136.74,
    x2: 319.38,
    y2: 142.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 307.97,
    y1: 165.21,
    x2: 313.1,
    y2: 163.94,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355.89,
    y1: 145.28,
    x2: 361.59,
    y2: 139.59,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 357.97,
    y1: 164.89,
    x2: 365.82,
    y2: 165.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "264.95 99.22 261.57 74.97 272.85 72.71",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 262.7,
    y1: 85.12,
    x2: 272.29,
    y2: 81.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 279.62,
    y1: 85.68,
    x2: 292.59,
    y2: 84.55,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 279.62,
    y1: 90.76,
    x2: 291.46,
    y2: 89.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.08,
    y1: 103.73,
    x2: 299.92,
    y2: 99.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.76,73.27s-2.25-5.63-4.51-.56-2.26,13.53.56,10.15a34,34,0,0,0,4.52-7.33l-2.26,23.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.6,72.15s-2.25-5.64-4.51-.57-2.25,13.54.57,10.15a33.67,33.67,0,0,0,4.51-7.33l-2.26,23.69",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.37,77.22s-2.82,2.26-2.26,0,3.18-4.28,4.52-.56c1.27,3.53,1.12,11.28-2.82,11.28s-1.13-4,7.33-2.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.17,96.77s-1.92,1.53-1.53,0,2.15-2.9,3.06-.38.77,7.66-1.91,7.66-.77-2.68,5-1.53",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 305.56,
    y1: 103.16,
    x2: 342.21,
    y2: 98.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "312.32 105.42 310.07 114.44 317.4 114.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 319.66,
    y1: 107.11,
    x2: 316.27,
    y2: 120.64,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320.78,
    y1: 113.31,
    x2: 329.7,
    y2: 111.56,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.13,120.08c.16-.47,1.42-7.1,1.42-7.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 327.18,
    y1: 112.03,
    x2: 325.44,
    y2: 120.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.56,103.7s-5.66.87-5.22,3,3.91,2.18,3.91,2.18-8.7,3-6.53,8.71,9.15-1.75,9.15-1.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.22,109.8s-1.3,12.19-1.74,7.84,3.48-8.28,4.79-7.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.72 161.74 236.62 175.04 237.88 199.75 256.26 209.89 273.36 197.22 271.46 172.51 253.72 161.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 253.09,
    y1: 154.14,
    x2: 253.09,
    y2: 168.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 272.1,
    y1: 182.64,
    x2: 279.06,
    y2: 182.64,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 230.28,
    y1: 187.08,
    x2: 240.42,
    y2: 185.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 256.26,
    y1: 206.72,
    x2: 256.26,
    y2: 218.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.72,142.42c0,3.67-1.56,6.65-3.48,6.65s-3.49-3-3.49-6.65,1.56-6.66,3.49-6.66S253.72,138.74,253.72,142.42Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 207.64,
    cy: 188.07,
    rx: 3.48,
    ry: 6.65,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.29,177.89c0,3.68-1.56,6.66-3.49,6.66s-3.48-3-3.48-6.66,1.56-6.65,3.48-6.65S300.29,174.22,300.29,177.89Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "256.26 148.43 255.62 135.13 262.59 147.8 263.23 135.76",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "219.67 193.77 219.04 180.47 226.01 193.14 226.64 181.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "282.87 184.54 282.23 171.24 289.2 183.91 289.83 171.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.44,228.58c0,3.67-1.56,6.65-3.48,6.65s-3.49-3-3.49-6.65,1.56-6.66,3.49-6.66S265.44,224.9,265.44,228.58Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "248.02 235.23 247.39 221.92 254.36 234.59 254.99 222.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.51,178.8s-1.91,1.53-1.53,0,2.15-2.9,3.06-.38.77,7.66-1.91,7.66-.77-2.68,5-1.53",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.44,193.1s-1.91,1.53-1.53,0,2.16-2.91,3.07-.39.76,7.66-1.92,7.66-.76-2.68,5-1.53",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.4,
    y1: 85.4,
    x2: 55.86,
    y2: 107.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.32,88.1S71,87,66.68,89.18a72.71,72.71,0,0,0-10.28,7s16.23,2.17,8.11,5.41-13.52.54-13.52.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.33,98.11s-1.63,1.31-1.31,0,1.84-2.47,2.62-.32.65,6.54-1.64,6.54S70.35,102,75.25,103",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.77,89.18s-10.82.74-8.65,3.68,13.52,5.52,10.81,7.68a21.53,21.53,0,0,1-10.81,4.84",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5,96.75c0,3.89-1.33,7-3,7s-3-3.15-3-7,1.34-7,3-7S97.5,92.87,97.5,96.75Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 219.37,
    cy: 97.82,
    rx: 13.48,
    ry: 32.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 219.37,
    cy: 97.82,
    rx: 32.6,
    ry: 13.48,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 219.37,
    cy: 97.82,
    rx: 32.6,
    ry: 13.48,
    transform: "translate(-4.92 183.77) rotate(-45)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 219.37,
    cy: 97.82,
    rx: 13.48,
    ry: 32.6,
    transform: "translate(-4.92 183.77) rotate(-45)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.43,98.38a5,5,0,1,1-5-5A5,5,0,0,1,223.43,98.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,74a2.52,2.52,0,1,1-2.52-2.51A2.52,2.52,0,0,1,207,74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.49,97.82A2.52,2.52,0,1,1,252,95.3,2.52,2.52,0,0,1,254.49,97.82Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-143"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "412.85 365.04 412.53 468.59 408.97 468.59 400.88 365.04 412.85 365.04",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.33 365.04 452.01 468.59 448.45 468.59 440.36 365.04 452.33 365.04",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.31 370.4 440.78 370.4 440.36 365.04 452.33 365.04 452.31 370.4",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.32 365.04 397.64 468.59 401.2 468.59 409.29 365.04 397.32 365.04",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.87 370.4 397.33 370.4 397.32 365.04 409.29 365.04 408.87 370.4",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.19 365.04 344.52 468.59 348.08 468.59 356.17 365.04 344.19 365.04",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.75 370.4 344.21 370.4 344.19 365.04 356.17 365.04 355.75 370.4",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.72,275.8l-7.52,84.68H386L383.2,274.9a9,9,0,0,1,9-9.26l60.63.4A9,9,0,0,1,461.72,275.8Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.53,275.8,450,360.48H381.84L379,274.9a9,9,0,0,1,9-9.26l60.64.4A9,9,0,0,1,457.53,275.8Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.81,
    y: 358.55,
    width: 115.43,
    height: 7.69,
    transform: "translate(795.05 724.8) rotate(180)",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.24,358.55l-1-1.47a15.12,15.12,0,0,0-12.54-6.67H353.64A15.1,15.1,0,0,0,342,355.92l-2.16,2.63Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.81,
    y: 358.55,
    width: 65.45,
    height: 7.69,
    transform: "translate(745.07 724.8) rotate(180)",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.32,286.8a5,5,0,0,1,0,6.22h35l1.32-3.39-1.69-3Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.36,292.86v-5.68H399v-1.42h46.15a4.26,4.26,0,1,1,0,8.52H399v-1.42Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.36,290h0a2.84,2.84,0,0,0-2.84-2.84H394.63v-1.42h34.69a4.09,4.09,0,0,1,4.09,4.09h0a4.43,4.43,0,0,1-4.43,4.43H394.63v-1.42h33.89A2.84,2.84,0,0,0,431.36,290Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.49,278.18a5,5,0,0,1,0,6.22h35l1.32-3.39-1.69-3Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.53,284.24v-5.68H398.21v-1.42h46.15a4.26,4.26,0,0,1,0,8.52H398.21v-1.42Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.53,281.4h0a2.84,2.84,0,0,0-2.84-2.84H393.8v-1.42h34.69a4.09,4.09,0,0,1,4.09,4.09h0a4.43,4.43,0,0,1-4.44,4.43H393.8v-1.42h33.89A2.84,2.84,0,0,0,430.53,281.4Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 449.12,
    y1: 281.88,
    x2: 447.4,
    y2: 265.68,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.39,266.14s-3.1-2.41-3.1-7.93,4.13-10,4.13-10,4.48,5.51,3.45,11S447.39,266.14,447.39,266.14Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.71,280.68a71.39,71.39,0,0,1,5.49-11.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.58,272.44s-1.72-3.54.71-8.48,8.12-7.14,8.12-7.14,1.59,6.92-1.77,11.41S454.58,272.44,454.58,272.44Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.32,282.13a44.48,44.48,0,0,0-3.79-9L440.12,269",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.06,272.23a11.8,11.8,0,0,1-11.16-2.32c-5.35-4.5-5-13.67-5-13.67s10.37-1.48,14.56,4.4A12.33,12.33,0,0,1,442.06,272.23Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.13,
    y: 276.71,
    width: 17.92,
    height: 17.57,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 302.16,
    y1: 284.77,
    x2: 318.24,
    y2: 223.42,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.17,222.26h0a1.26,1.26,0,0,0,.92,1.52,30.85,30.85,0,0,1-15.22,59.79,1.22,1.22,0,0,0-1.49.88v.06a1.2,1.2,0,0,0,.87,1.47,33.34,33.34,0,0,0,16.44-64.62A1.24,1.24,0,0,0,315.17,222.26Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.16,
    cy: 253.59,
    r: 28.19,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.86 292.25 301.68 292.25 302.39 285.91 307.14 285.91 307.86 292.25",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.37,294.28h-29a2.71,2.71,0,0,1,2.72-2.71h23.54a2.71,2.71,0,0,1,2.72,2.71Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.58,246.7c2,.67,2.35,0,3.35,1s3,3.69,2.69,5.7-1.35,4,0,4,2.68-2,2.68-3,.67-5.71.67-5.71l.59-1.75a28.2,28.2,0,0,0-10.82-16.16l-.84.13-2.69,1.67c-2,0-2.68-.67-4-.67a5.19,5.19,0,0,0-3.69,1c-1.34,1-2.68,3-1.34,3.36a10.5,10.5,0,0,0,3,.33c1,0,1.34-1,1,0a3,3,0,0,1-2.69,1.68,14,14,0,0,1-3-.67c-3-1-4.36-1.68-5.7-1s-2.69.67-3,1.68a27.19,27.19,0,0,0-.68,3,1.51,1.51,0,0,0,2.35.67,12.67,12.67,0,0,1,3-1.34h1.35l1.34,2.35,1.34,1.34a5.38,5.38,0,0,0,.34-3c1-.67,3,1.68,3,1.68l1.68.33,3,.68,1,2.35-4.36-1.68s-1.68,1.68-1,2.68a9.16,9.16,0,0,1,1,2,26.68,26.68,0,0,0-5-1.68c-2-.34-3,.33-3.7-.67s-1.34-3-2.35-3.36a10.6,10.6,0,0,0-2.68-.34,5.87,5.87,0,0,0-3.69,1.35c-1.34,1.34-2,1-2.69,2.68a22,22,0,0,0-1,4.37s-1,0-1,2a23.93,23.93,0,0,0,.67,4.7l2.69,2.35a6.61,6.61,0,0,0,2.34.67h3.36l2.35.67a4.27,4.27,0,0,1,.67,2,6.17,6.17,0,0,0,.67,3,6.9,6.9,0,0,0,2,2.68v2.69a18.19,18.19,0,0,0-.34,3c0,1.34,2.34,3.18,2.34,3.18l2.7-.5s2.35,0,2.68-1.68a9.54,9.54,0,0,1,1.34-3.69,13.44,13.44,0,0,0,1.68-3,28,28,0,0,0,1.34-5c.34-2.35.68-3.7.68-3.7l3.69-4.36s1.34-1.34,1-2.68-3-1.35-3-1.35l3.7-3L323.9,247S323.56,246,325.58,246.7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.51,270.55s-6.78,5.35-3.21,4.28A4.12,4.12,0,0,0,323.51,270.55Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.89 468.59 254.81 468.59 252.33 296 259.12 296 258.89 468.59",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.26 468.59 258.19 468.59 257.95 296 264.75 296 262.26 468.59",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.45 468.59 280.37 468.59 277.89 296 284.68 296 284.45 468.59",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.82 468.59 283.75 468.59 283.51 296 290.31 296 287.82 468.59",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.92,
    y: 320.36,
    width: 43.21,
    height: 67.9,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.62,
    y: 320.36,
    width: 30.86,
    height: 67.9,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "442.84 468.59 438.77 468.59 436.28 296 443.07 296 442.84 468.59",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "446.22 468.59 442.14 468.59 441.91 296 448.7 296 446.22 468.59",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "462.27 468.59 458.19 468.59 455.71 296 462.5 296 462.27 468.59",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "465.64 468.59 461.57 468.59 461.33 296 468.13 296 465.64 468.59",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.48,
    y: 296,
    width: 223.51,
    height: 24.85,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.12,
    y: 296,
    width: 27.87,
    height: 24.85,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.48,
    y: 296,
    width: 223.51,
    height: 10.54,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.68,
    y: 294,
    width: 229.12,
    height: 6.4,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.31,
    y: 294,
    width: 27.49,
    height: 6.4,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-143"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137.97,
    y: 462.86,
    width: 24.35,
    height: 6.14,
    rx: 1.14,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.62,345.11s-7.91,25-7.91,31,0,21.22-3.81,34.85-8.87,28.19-9.18,29.77a18.28,18.28,0,0,0-.32,3.17s10.77,15.52,10.77,17.74-2.22,2.85-3.48,2.85H139.31s-1.26-.63-1.9-6.34,1-16.15,1-17.42-1.9-18.37-4.75-28.19-2.85-26.29-2.53-30.41,1.9-10.77,1.9-13v-17.1Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.54,457.47s3,3,2.61,4.56a8,8,0,0,1-1.09,2.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.67,457.47s2.83,1.52,2.39,3.91a27.57,27.57,0,0,1-.65,3.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.71,457.25s3.27,3.48,2,5.22a7,7,0,0,1-2,2.06",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.85,358.39s25,2,30.75-3.88l1.29-5.18-34,3.56Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.71,458.31s.91-.23,2.73,1.13,2.51,3.64.46,4.55",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.36,456.06c-1-1.59-2.08-3.33-3.16-5a38.64,38.64,0,0,0-17.78-.26c-.09,1.34-.15,2.69-.15,4A35.47,35.47,0,0,1,158.36,456.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.16,
    y: 462.86,
    width: 25.94,
    height: 6.14,
    rx: 1.14,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.48,344.21s9.85,21.87,8.75,29.89-6.19,25.52-2.18,38.28,8.75,27.71,9.48,29.9S106.78,458,105,460.87s2.92,4,5.84,4H126.1s2.19-.73,2.19-4-3.28-16.77-1.46-25.15,5.83-27,9.84-44.48,2.92-38.65,2.92-38.65Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.21,459.72S106,463.2,107,464.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.26,459.94s-2.83,2.83-1.74,4.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,459.72s-3,3.26-1.3,4.79",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.18,356.13s23.63,5.82,35.28,1l.13-4.51-37-2Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.45,458.31a7.15,7.15,0,0,0-1.82,2.73c-.91,2-.23,2.95,1.37,3.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.7,456.05c-.19-1.26-.41-2.67-.61-4.18-7.23-2.13-12.37-1.77-15.74-.81-1.29,2.07-2.67,4.17-3.85,5.94a1.9,1.9,0,0,0,1.33-.54C108.89,456.41,114.18,451.48,127.7,456.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.66,268.29s-5.7,12.83-2.85,33.26,12.36,47.52,12.36,47.52a177.68,177.68,0,0,0,45.13,5.7c25.66,0,38-6.18,38-6.18s9.5-36.11,9.5-56.07-5.23-31.35-5.23-31.35-45.61,10-87.9-4.28Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.29,
    y1: 328.23,
    x2: 142.91,
    y2: 330.56,
    style: {
      fill: "none",
      stroke: "#787878",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.81,
    y1: 298.87,
    x2: 139.39,
    y2: 325.52,
    style: {
      fill: "none",
      stroke: "#787878",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 136.8,
    y1: 313.4,
    x2: 147.56,
    y2: 327.65,
    style: {
      fill: "none",
      stroke: "#787878",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,352.36s28.19,5.81,62.79-1.16",
    style: {
      fill: "none",
      stroke: "#787878",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.75,165.66l-21.38-1.43s5.23,34.69-2.38,56.07-13.3,36.59-13.3,36.59l-5.23,10a162.45,162.45,0,0,0,34.21,8.07c17.59,1.9,33.74,2.86,42.29.95a135.85,135.85,0,0,0,17.11-5.22S162.91,229.33,162.91,207a149.65,149.65,0,0,0-5.11-39.22l-8.23-1Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.05 191.16 142.47 276.83 148.23 277.65 149.05 191.16",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.33,141.66c1,1.61-.06,16-.21,18.89s-1.44,5-4.54,4.16c-6.67-1.88-5.23,2.61-5.23,2.61s-.95,10.46,4.27,19,19.25,10.21,25.66,6.18,7.37-23.66,7.37-23.66l-4.08-2a6.19,6.19,0,0,1-3.42-5.7l.61-11.37S132.74,151.64,126.33,141.66Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.76,149.74s-14,1.9-20.43-8.08c.94,1.48.11,13.62-.16,17.91a14.24,14.24,0,0,0,6.52,3c4.73.54,9.69-1.44,13.6-3.93Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.2,164s-11.89-.47-22.58-.71-15.92.72-20,2.86-30.41,26.6-32.07,30.64-3.37,8.85,6.85,9.09,31.4-6.24,31.4-6.24S95.68,220.3,95,229.57s-6.89,23.28-12.12,31.6-5.23,12.11-5.23,12.11,5.71,9.27,20.67,12.83a141.3,141.3,0,0,0,26.85,3.8l-2.38-53.45Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "84.05 188.88 87.84 199.63 82.19 192.59",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.81,188.47l-29.6,15.34c1.07,1.18,3.24,2,7.23,2.06a54.19,54.19,0,0,0,9.79-1Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.7,163.94c0,7,0,32.06,1.17,44.48,1,10.44,4.89,23.33,7,29.74l-.08-1.7L124.2,164S120.18,164,114.7,163.94Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.57,166.81s-1.62,54.68-2.1,62.52-3.09,61.29-3.09,61.29a50.55,50.55,0,0,0,21.86-5c11.4-5.47,17.58-9.51,19-11.88s-1.19-6.89-3.33-13.78-5.23-17.35-5.94-20.91-.24-12.35-.24-12.35,11.41,11.16,14.73,10.21,25.66,5.47,26.14,3.8-18.54-35.87-25.19-50.84-16.15-18.9-22.57-20.33S149.57,166.81,149.57,166.81Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.8,167.78c-4.47-.58-8.23-1-8.23-1s-1.62,54.68-2.1,62.52c-.12,1.94-.37,6.68-.67,12.72,2.12-6.48,7-22.15,8.51-32.68C156.81,198.67,157.48,175.9,157.8,167.78Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.29 181.81 148.18 235.75 151.03 237.88 168.85 183.48 165.29 181.81",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.85 183.48 201.4 195.36 182.63 243.59 151.03 237.88 168.85 183.48",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.71 189.89 149.61 243.82 152.46 245.96 170.28 191.56 166.71 189.89",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.28 191.56 202.83 203.43 184.06 251.66 152.46 245.96 170.28 191.56",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,206.52s-6.41-3.8-8.55-4a3.37,3.37,0,0,0-3.95,3.12,8,8,0,0,0,.46,3s-2.32.62-3.4,6.76c-.38,2.16-1.43,3.8,0,5.47a13.91,13.91,0,0,0,8.79,4.51,72.36,72.36,0,0,1,10.45,2.38A164.33,164.33,0,0,0,186,242.4c8.55,6.65,16.15,14.25,22.57,13.06s10.45-8.55,8.08-14.73-36.35-19.95-37.54-20.43a15.24,15.24,0,0,1-3.09-2.14s0-5.22-1.19-7.6-5-5.94-5-9.26.24-4.76-1.66-4.28S165.05,203.43,166,206.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.74,121.61s-3-7.56-5.21-2.52c-2.7,6.24,2.52,12.43,3.87,13.27S120.74,121.61,120.74,121.61Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.12,127s3.85-4.74,5-.59-2.37,8.3-5,10.08-3.56,4.15-3.56.89S164.12,127,164.12,127Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.91,63.32s-6.22-4.53-10.42.67.17,9.08-2.86,10.25-5-4.2-11.25,1-2.18,9.41-1.85,11.25-.84,1.85-5.54,3.87-7.22,6.88-1,11.92,9.24-2.18,10.08,1.18,0,6.22,4.2,6,12.6-7.06,17.81-3.87,10.91,11.26,14.78,8.74,5.21-6.89,8.57-4.7,8.06,3.19,10.75-3.7-2.69-9.24-1.85-12.93,5.54-8.57,1.51-14.28-8.06.33-12.26-5,.17-10.92-5.21-13.95A11.29,11.29,0,0,0,141.91,64",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.36,101.75s-6.23,5.34-6.82,12.16-3.26,23.12-.3,29.35,10.36,15,16.9,15.71c9.19,1.06,19.27-7.41,20.75-10.67s9.52-26.39,7.71-36.77C163.23,97.9,140.4,89,127.36,101.75Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.6,111.53c-2.37-13.63-25.2-22.53-38.24-9.78,0,0-6.23,5.34-6.82,12.16-.17,1.93-.5,4.62-.83,7.63a9.09,9.09,0,0,0,3.21-6.14c.34-4.2,3.87-8.57,17.31-10.42s21,8.07,22.17,11.59-.5,8.23.34,10.59a2.48,2.48,0,0,0,1.18,1.61C165.4,122.38,166.35,115.85,165.6,111.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.73,85.15a4.31,4.31,0,0,0-.39.46c-1.11,1.58-2,1.68-3.83,1.06-4-1.34-7.39.51-7.22,3.87s1.68,2.85-1.34,5-5.55,3.7-3.87,7.73S128,105.15,128,108s-.17,6.55,4,6.55,7.06-5,8.24-2.35,2.52,6.55,6.21,5.87,5.71-6.55,9.41-3.69,5.71,5.37,7.73,3-.17-5.88,2.52-7.39,5.2-2.18,3.69-7.22-3.69-2.52-5.37-6.39-1.35-8.06-4.54-8.73-4.7,1.51-7.73,1.18c-2.58-.29-3.6-3.43-5.78-4.48S140.55,83.35,138.73,85.15Z",
    style: {
      fill: "#263238",
      stroke: "#787878",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.44,125.79s-1.48,4.15-.89,6.82,2.08,5-.3,5.34-4.15-1.19-4.15-2.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.72,139a10.62,10.62,0,0,0,8,4.15,15.6,15.6,0,0,0,8.6-2.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.49,125.73c-.14,1.39-.87,2.46-1.63,2.38s-1.27-1.26-1.13-2.65.87-2.45,1.63-2.38S136.63,124.34,136.49,125.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.09,128.17c-.14,1.39-.87,2.45-1.63,2.38s-1.27-1.27-1.13-2.66.87-2.45,1.63-2.38S150.23,126.78,150.09,128.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.6,122.68A9.46,9.46,0,1,1,132,113.4,9.47,9.47,0,0,1,141.6,122.68Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.62,126.69a9.46,9.46,0,1,1-9.64-9.28A9.47,9.47,0,0,1,162.62,126.69Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.62,
    y1: 123.69,
    x2: 143.83,
    y2: 124.2,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.81,
    y1: 120.19,
    x2: 119.86,
    y2: 119.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 162.62,
    y1: 126.69,
    x2: 164.83,
    y2: 127.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.88,119a8.43,8.43,0,0,1,7.94-1.7",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.68,124.88a8.43,8.43,0,0,0-6.82-4.42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.36,126a69.94,69.94,0,0,1,6.81-8.21c3.6-3.61,8.41-5.21,8.41-3s-3.2,2.6-5.41,5.4-7.41,10.22-7.61,12.22,0,5.41,3.61,4.81,7.61-4,9.41-5.21,6.81,0,5,1.61-5,2.4-7.61,4.6-6.81,6.61-9,7.82-3.8,2-3.8,2-.8.8-3.61,5.61-11.62,18.63-17,24.64-25.64,26-30.64,27.84-17.23.2-19-6.21,2.4-13.82,11.41-20.23,34.66-21.24,40.27-24.24,7.81-4.61,8-6.21,2.8-12,5.21-16.23A30.29,30.29,0,0,1,110.36,126Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.89,136.23s1-7.13,2.06-8.08,7.44-.79,8.71-.16,1.26,6.34.79,7.61-1.27,2.05-1.74,1.58-1.43-5.23-1.43-5.23l-3.32-.47-1.11,4.75",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.25,138.45s1-7.13,2.06-8.08,7.45-.79,8.71-.16,1.27,6.34.8,7.6-1.27,2.06-1.75,1.59-1.42-5.23-1.42-5.23l-3.33-.48-1.11,4.76",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.94,141.35s.9-6.75,2-7.65,7-.75,8.25-.15,1.2,6,.75,7.2-1.2,1.95-1.65,1.5-1.35-4.95-1.35-4.95l-3.15-.45-1,4.5",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.29,138.66s.86,5.9-.73,9-3.44,3.07-3.44,3.07",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-143"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 24.96,
    y1: 469,
    x2: 483,
    y2: 469,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9502987861633301px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacherBro);
export default __webpack_public_path__ + "static/media/Teacher-bro.27c231fc0c844143f96b7054ec54a916.svg";
export { ForwardRef as ReactComponent };